export const project_type = [
  { value: "all", text: "All" },
  { value: "CloudExt PBX", text: "CloudExt PBX" },
  { value: "kiosk", text: "Kiosk" },
  { value: "lock", text: "Lock App" },
  { value: "guest_xp_app", text: "GuestXP App" },
  { value: "video_bot", text: "Video Bot" },
  { value: "super_admin", text: "Super Admin" },
  { value: "ID Scan Desktop", text: "ID Scan Desktop" },
];

export const non_super_user = [
  { value: "All", text: "All" },
  { value: "booking", text: "Booking" },
  { value: "kiosk_Admin", text: "Kiosk Admin" },
  { value: "settings", text: "Settings" },
  { value: "requests", text: "Requests" },
  { value: "misc", text: "Miscellaneous" },
];

export const service_provider = [
  { value: "TYX", text: "TYX" },
  { value: "SKY", text: "SKY" },
  { value: "TNX", text: "TNX" },
  { value: "BVS", text: "BVS" },
  { value: "BWT", text: "BWT" },
];

export const routes = [
  { value: "", text: "Selected" },
  { value: "Extension", text: "Extension" },
  { value: "RingGroup", text: "RingGroup" },
  { value: "CallFlow", text: "CallFlow" },
  { value: "IVR", text: "IVR" },
  { value: "VoiceMail", text: "VoiceMail" },
  { value: "Tones", text: "Tones" },
  { value: "Others", text: "Others" },
];

export const page_conditions = [
  { value: "anytime", text: "Anytime" },
  { value: "checkin", text: "Check-In" },
  { value: "checkout", text: "Check-Out" },
  { value: "new_booking", text: "New Booking" },
  { value: "guest_portal", text: "Guest Code" },
  { value: "lock", text: "Lock" },
];
export const date_formate = [
  { text: "MMM-DD-YYYY", value: "MMM-DD-YYYY", disabled: false },
  { text: "DD-MM-YYYY", value: "DD-MMM-YYYY", disabled: false },
  { text: "YYYY-MM-DD", value: "YYYY-MMM-DD", disabled: false },
  { text: "YYYY-DD-MM", value: "YYYY-DD-MMM", disabled: false },
  { text: "MM/DD/YYYY", value: "MM/DD/YYYY", disabled: false },
  { text: "DD/MM/YYYY", value: "DD/MM/YYYY", disabled: false },
  { text: "YYYY/MM/DD", value: "YYYY/MM/DD", disabled: false },
  { text: "YYYY/DD/MM", value: "YYYY/DD/MM", disabled: false },
];

export const time_formate = [
  { text: "HH:MM:SS", value: "HH:MM:SS", disabled: false },
  { text: "HH:MM:SS XM", value: "HH:MM:SS XM", disabled: false },
  { text: "HH:MM", value: "HH:MM", disabled: false },
  { text: "HH:MM XM", value: "HH:MM XM", disabled: false },
];

export const date_time_formate = [
  {
    text: "MMM-DD-YYYY HH:MM:SS",
    value: "MMM-DD-YYYY HH:MM:SS",
    disabled: false,
  },
  {
    text: "MMM-DD-YYYY HH:MM:SS XM",
    value: "MMM-DD-YYYY HH:MM:SS XM",
    disabled: false,
  },
  { text: "MMM-DD-YYYY HH:MM", value: "MMM-DD-YYYY HH:MM", disabled: false },
  {
    text: "MMM-DD-YYYY HH:MM XM",
    value: "MMM-DD-YYYY HH:MM XM",
    disabled: false,
  },

  {
    text: "DD-MM-YYYY HH:MM:SS",
    value: "DD-MMM-YYYY HH:MM:SS",
    disabled: false,
  },
  {
    text: "DD-MM-YYYY HH:MM:SS XM",
    value: "DD-MMM-YYYY HH:MM:SS XM",
    disabled: false,
  },
  { text: "DD-MM-YYYY HH:MM", value: "DD-MMM-YYYY HH:MM", disabled: false },
  {
    text: "DD-MM-YYYY HH:MM XM",
    value: "DD-MMM-YYYY HH:MM XM",
    disabled: false,
  },

  {
    text: "YYYY-MM-DD HH:MM:SS",
    value: "YYYY-MMM-DD HH:MM:SS",
    disabled: false,
  },
  {
    text: "YYYY-MM-DD HH:MM:SS XM",
    value: "YYYY-MMM-DD HH:MM:SS XM",
    disabled: false,
  },
  { text: "YYYY-MM-DD HH:MM", value: "YYYY-MMM-DD HH:MM", disabled: false },
  {
    text: "YYYY-MM-DD HH:MM XM",
    value: "YYYY-MMM-DD HH:MM XM",
    disabled: false,
  },

  {
    text: "YYYY-DD-MM HH:MM:SS",
    value: "YYYY-DD-MMM HH:MM:SS",
    disabled: false,
  },
  {
    text: "YYYY-DD-MM HH:MM:SS XM",
    value: "YYYY-DD-MMM HH:MM:SS XM",
    disabled: false,
  },
  { text: "YYYY-DD-MM HH:MM", value: "YYYY-DD-MMM HH:MM", disabled: false },
  {
    text: "YYYY-DD-MM HH:MM XM",
    value: "YYYY-DD-MMM HH:MM XM",
    disabled: false,
  },

  {
    text: "MM/DD/YYYY HH:MM:SS",
    value: "MM/DD/YYYY HH:MM:SS",
    disabled: false,
  },
  {
    text: "MM/DD/YYYY HH:MM:SS XM",
    value: "MM/DD/YYYY HH:MM:SS XM",
    disabled: false,
  },
  { text: "MM/DD/YYYY HH:MM", value: "MM/DD/YYYY HH:MM", disabled: false },
  {
    text: "MM/DD/YYYY HH:MM XM",
    value: "MM/DD/YYYY HH:MM XM",
    disabled: false,
  },

  {
    text: "DD/MM/YYYY HH:MM:SS",
    value: "DD/MM/YYYY HH:MM:SS",
    disabled: false,
  },
  {
    text: "DD/MM/YYYY HH:MM:SS XM",
    value: "DD/MM/YYYY HH:MM:SS XM",
    disabled: false,
  },
  { text: "DD/MM/YYYY HH:MM", value: "DD/MM/YYYY HH:MM", disabled: false },
  {
    text: "DD/MM/YYYY HH:MM XM",
    value: "DD/MM/YYYY HH:MM XM",
    disabled: false,
  },

  {
    text: "YYYY/MM/DD HH:MM:SS",
    value: "YYYY/MM/DD HH:MM:SS",
    disabled: false,
  },
  {
    text: "YYYY/MM/DD HH:MM:SS XM",
    value: "YYYY/MM/DD HH:MM:SS XM",
    disabled: false,
  },
  { text: "YYYY/MM/DD HH:MM", value: "YYYY/MM/DD HH:MM", disabled: false },
  {
    text: "YYYY/MM/DD HH:MM XM",
    value: "YYYY/MM/DD HH:MM XM",
    disabled: false,
  },

  {
    text: "YYYY/DD/MM HH:MM:SS",
    value: "YYYY/DD/MM HH:MM:SS",
    disabled: false,
  },
  {
    text: "YYYY/DD/MM HH:MM:SS XM",
    value: "YYYY/DD/MM HH:MM:SS XM",
    disabled: false,
  },
  { text: "YYYY/DD/MM HH:MM", value: "YYYY/DD/MM HH:MM", disabled: false },
  {
    text: "YYYY/DD/MM HH:MM XM",
    value: "YYYY/DD/MM HH:MM XM",
    disabled: false,
  },
];

export const company_type = [
  { text: "Agent", value: "agent", disabled: false },
  { text: "OTA", value: "ota", disabled: false },
];

export const contact_designation = [
  { text: "CEO", value: "ceo", disabled: false },
  { text: "Account Team", value: "account_team", disabled: false },
];

export const payment_gateway_type = [
  { text: "Stripe", value: "stripe", disabled: false },
];

export const days = [
  { text: "All", value: "All", disabled: false },
  { text: "Sunday", value: "Sunday", disabled: false },
  { text: "Monday", value: "Monday", disabled: false },
  { text: "Tuesday", value: "Tuesday", disabled: false },
  { text: "Wednesday", value: "Wednesday", disabled: false },
  { text: "Thursday", value: "Thursday", disabled: false },
  { text: "Friday", value: "Friday", disabled: false },
  { text: "Saturday", value: "Saturday", disabled: false },
];

export const answer_type = [
  { text: "Short Text", value: "text", disabled: false },
  { text: "Date", value: "date", disabled: false },
  { text: "Time", value: "time", disabled: false },
  { text: "Phone", value: "phone", disabled: false },
  { text: "Email", value: "email", disabled: false },
  { text: "Yes/No", value: "radio", disabled: false },
  { text: "Number", value: "number", disabled: false },
  { text: "Long Text", value: "textarea", disabled: false },
  { text: "Choice", value: "choice", disabled: false },
  { text: "Multi Select", value: "multi_select", disabled: false },
  { text: "Select", value: "select", disabled: false },
  { text: "File Upload", value: "file", disabled: false },
];

export const kiosk_policy = [
  { text: "Kiosk", value: "is_kiosk" },
  { text: "New Booking", value: "is_new_booking" },
  { text: "Check In", value: "is_check_in" },
  { text: "Check Out", value: "is_check_out" },
  { text: "Collect Key", value: "is_collect_key" },
  { text: "Selfie", value: "is_selfie" },
  { text: "ID Capture", value: "is_id_caputre" },
  { text: "ID Verification", value: "is_id_verification" },
  { text: "Photo Verification", value: "is_photo_verification" },
  { text: "Signature", value: "is_signature" },
  { text: "Contact Update", value: "is_contact_update" },
  { text: "Additional Questions", value: "is_additional_question" },
  { text: "Upsell", value: "is_upsell" },
  { text: "Room Select", value: "is_room_select" },
  { text: "Room Upgrade", value: "is_room_updrage" },
  { text: "Video Chat", value: "is_video_chat" },
  { text: "Message Chat", value: "is_message_chat" },
];

export const multi_lang_options = [
  { text: "english", value: "english", tagPosition: "top", disabled: true },
  { text: "spanish", value: "spanish" },
  { text: "french", value: "french" },
  { text: "chinese", value: "chinese" },
  { text: "japanese", value: "japanese" },
];

export const user_type = [
  { text: "Super Admin", value: "super_admin", disabled: false },
  { text: "Hotel Admin", value: "hotel_admin", disabled: false },
  { text: "Hotel Staff", value: "hotel_staff", disabled: false },
  { text: "Kiosk Machine", value: "hiosk_machine", disabled: false },
];

export const work_shift = [
  { text: "Day", value: "day", disabled: false },
  { text: "Night", value: "night", disabled: false },
];

export const staff_type = [
  { text: "Full Time", value: "full_time", disabled: false },
  { text: "Part Time", value: "part_time", disabled: false },
  { text: "Permanent", value: "permenant", disabled: false },
];

export const gender_type = [
  { text: "Agender", value: "agender", disabled: false },
  { text: "Bigender", value: "bigender", disabled: false },
  { text: "Female", value: "female", disabled: false },
  { text: "Genderfluid", value: "genderfluid", disabled: false },
  { text: "Genderqueer", value: "genderqueer", disabled: false },
  { text: "Male", value: "male", disabled: false },
  { text: "Non-bianry", value: "non-bianry", disabled: false },
  { text: "Ploygender", value: "ploygender", disabled: false },
];

export const avatar_gender = [
  { text: "Male", value: "male", disabled: false },
  { text: "Female", value: "female", disabled: false },
];

export const documnet_type = [
  { text: "Driving Licence", value: "driving_licence", disabled: false },
  { text: "Passport", value: "passport", disabled: false },
  { text: "Other", value: "other", disabled: false },
];
export const documnet_status = [
  { text: "Pending", value: "P", disabled: false },
  { text: "Uploaded", value: "U", disabled: false },
  { text: "Rejected", value: "R", disabled: false },
  { text: "Verified", value: "V", disabled: false },
];

export const device_type = [
  { value: "web", text: "Web", disabled: false },
  { value: "ios", text: "iOS", disabled: false },
  { value: "android", text: "Android", disabled: false },
];

export const ccp_amount_type = [
  { value: "FA", text: "Fixed Amount", disabled: false },
  { value: "PBA", text: "% of Booking Amount", disabled: false },
  { value: "FN", text: "First Night", disabled: false },
];

export const booking_status = [
  { value: "", text: "Select", disabled: false },
  { value: "new_booking", text: "New", disabled: false },
  { value: "pre_checkin", text: "Pre CheckIn", disabled: false },
  { value: "pre_checked_done", text: "Pre CheckedIn Done", disabled: false },
  { value: "due_in_hold", text: "Due In-Hold", disabled: false },
  { value: "due_in", text: "Confirmed", disabled: false },
  { value: "checked_in", text: "Due In", disabled: false },
  { value: "due_out", text: "Checked In", disabled: false },
  { value: "checked_out", text: "Checked Out", disabled: false },
  { value: "cancelled", text: "Cancelled", disabled: false },
  { value: "no_show", text: "No Show", disabled: false },
];

export const reservation_amount_type = [
  { value: "PBA", text: "% of Booking Amount", disabled: false },
  { value: "FN", text: "First Night", disabled: false },
];

export const rp_amount_type = [
  { value: "PBA", text: "% of Booking Amount", disabled: false },
  { value: "FN", text: "First Night", disabled: false },
];

export const when_booking = [
  { value: "AFB", text: "After Booking", disabled: false },
  { value: "BCI", text: "Before Check-in", disabled: false },
  { value: "OAK", text: "On arrival (Hotel KIosk)", disabled: false },
];

export const when_booking_on_security_deposit = [
  { value: "BCI", text: "Before Check-in", disabled: false },
  { value: "OAK", text: "On arrival (Hotel KIosk)", disabled: false },
];

export const when_booking_additional_charge = [
  { value: "AFB", text: "Now", disabled: false },
  { value: "OAK", text: "On Arrival (Hotel Kiosk)", disabled: false },
];

export const hk_status = [
  { value: "c", text: "Clean", disabled: false },
  { value: "d", text: "Dirty", disabled: false },
  { value: "p", text: "Pickup", disabled: false },
];

export const staff_hk_status = [
  { value: "hk_pending", text: "Pending", disabled: false },
  { value: "hk_in_progres", text: "In Progress", disabled: false },
  { value: "hk_discrepancy", text: "Discrepancy", disabled: false },
  { value: "hk_dnd", text: "DND", disabled: false },
  { value: "hk_completed", text: "Completed", disabled: false },
  { value: "in_pending", text: "Inspection Pending", disabled: false },
  { value: "in_faield", text: "Inspection Reject", disabled: false },
  { value: "in_done", text: "Inspection Done", disabled: false },
  { value: "mark_delay_service", text: "Mark Delay Service", disabled: false },
];

export const booking_hk_type = [
  { value: "light", text: "Light", disabled: false },
  { value: "heavy", text: "Heavy", disabled: false },
  { value: "regular", text: "Regular", disabled: false },
  { value: "self", text: "Self", disabled: false },
];

export const task_sheet_sequence = [
  { value: "morning", text: "Morning", disabled: false },
  { value: "evening", text: "Evening", disabled: false },
];

export const occupancy_status = [
  { value: "v", text: "Vacant", disabled: false },
  { value: "o", text: "Occupied", disabled: false },
  { value: "b", text: "Blocked", disabled: false },
  { value: "ooo", text: "Out of Order", disabled: false },
  { value: "oos", text: "Out of Service", disabled: false },
];

export const kioskLane = [
  { value: "Ingenico Lane/3000", text: "Ingenico Lane/3000", disabled: false },
];

export const payment_gateways = [
  { value: "stripe", text: "Stripe", disabled: false },
  { value: "macrotech", text: "Macrotech", disabled: false },
];

export const periodOptions = [
  { value: "one_time", text: "One Time" },
  { value: "daily", text: "Daily" },
];
export const perOptions = [
  { value: "booking", text: "Booking" },
  { value: "guest", text: "Guest" },
  { value: "item", text: "Item" },
];
export const whenCanPurchaseOptions = [
  { value: "after_checked_in", text: "AFTER CHECK-IN" },
  { value: "on_arrival_kiosk", text: "ON ARRIVAL KIOSK" },
  { value: "before_checked_in", text: "BEFORE CHECK-IN" },
];
export const upSellPriceType = [
  { text: "Percentage", value: "percentage" },
  { text: "Amount", value: "amount" },
];

export const user_review_type = [
  { text: "kiosk", value: "Kiosk Feedback", disabled: false },
  { text: "kiosk check-In", value: "Kiosk Check-in", disabled: false },
  { text: "kiosk Check-Out", value: "Kiosk Check-out", disabled: false },
  { text: "kiosk Walk-In", value: "Kiosk Walk-in", disabled: false },
  { text: "kiosk Collect-Key", value: "Kiosk Collect-key", disabled: false },
  { text: "Wifi Portal", value: "wifi_portal", disabled: false },
  { text: "Guest Portal", value: "guest_portal", disabled: false },
];

export const email_recipient = [
  { value: "hotel", text: "Hotel", disabled: false },
  { value: "guest ", text: "Guest", disabled: false },
];

export const tax_fee_type = [
  { value: "fix_amount", text: "Fix Amount", disabled: false },
  { value: "percent", text: "Percent", disabled: false },
];

export const tax_rule_type = [
  { value: "per_room_per_stay", text: "per room per stay", disabled: false },
  { value: "per_room_per_night", text: "per room per night", disabled: false },
  { value: "per_stay", text: "per stay", disabled: false },
  { value: "per_night", text: "per night", disabled: false },
  { value: "per_guest_per_stay", text: "per guest per stay", disabled: false },
  { value: "per_adult_per_stay", text: "per adult per stay", disabled: false },
  { value: "per_child_per_stay", text: "per child per stay", disabled: false },
  {
    value: "per_guest_per_night",
    text: "per guest per night",
    disabled: false,
  },
  {
    value: "per_adult_per_night",
    text: "per adult per night",
    disabled: false,
  },
  {
    value: "per_child_per_night",
    text: "per child per night",
    disabled: false,
  },
];

export const tax_rule_applied = [
  { value: "at_booking", text: "At Booking", disabled: false },
  { value: "at_arrival", text: "At Arrival", disabled: false },
];

export const booking_guest_type = [
  { value: "individual", text: "Individual", disabled: false },
  { value: "company", text: "Company", disabled: false },
];

export const booking_bill_to = [
  { value: "guest", text: "Guest", disabled: false },
  { value: "company", text: "Company", disabled: false },
];

export const iot_device_type = [
  { value: "all", text: "All", disabled: false },
  { value: "lock", text: "Lock", disabled: false },
  { value: "wall_reader", text: "Wall Reader", disabled: false },
  { value: "ac_controller", text: "AC Controller", disabled: false },
  { value: "light_controller", text: "Light Controller", disabled: false },
  { value: "em_lock_controller", text: "EMLock Controller", disabled: false },
];

export const percentages = [
  { value: 1, text: "1 %", disabled: false },
  { value: 2, text: "2 %", disabled: false },
  { value: 3, text: "3 %", disabled: false },
  { value: 4, text: "4 %", disabled: false },
  { value: 5, text: "5 %", disabled: false },
  { value: 6, text: "6 %", disabled: false },
  { value: 7, text: "7 %", disabled: false },
  { value: 8, text: "8 %", disabled: false },
  { value: 9, text: "9 %", disabled: false },
  { value: 10, text: "10 %", disabled: false },
  { value: 11, text: "11 %", disabled: false },
  { value: 12, text: "12 %", disabled: false },
  { value: 13, text: "13 %", disabled: false },
  { value: 14, text: "14 %", disabled: false },
  { value: 15, text: "15 %", disabled: false },
  { value: 16, text: "16 %", disabled: false },
  { value: 17, text: "17 %", disabled: false },
  { value: 18, text: "18 %", disabled: false },
  { value: 19, text: "19 %", disabled: false },
  { value: 20, text: "20 %", disabled: false },
  { value: 21, text: "21 %", disabled: false },
  { value: 22, text: "22 %", disabled: false },
  { value: 23, text: "23 %", disabled: false },
  { value: 24, text: "24 %", disabled: false },
  { value: 25, text: "25 %", disabled: false },
  { value: 26, text: "26 %", disabled: false },
  { value: 27, text: "27 %", disabled: false },
  { value: 28, text: "28 %", disabled: false },
  { value: 29, text: "29 %", disabled: false },
  { value: 30, text: "30 %", disabled: false },
  { value: 31, text: "31 %", disabled: false },
  { value: 32, text: "32 %", disabled: false },
  { value: 33, text: "33 %", disabled: false },
  { value: 34, text: "34 %", disabled: false },
  { value: 35, text: "35 %", disabled: false },
  { value: 36, text: "36 %", disabled: false },
  { value: 37, text: "37 %", disabled: false },
  { value: 38, text: "38 %", disabled: false },
  { value: 39, text: "39 %", disabled: false },
  { value: 40, text: "40 %", disabled: false },
  { value: 41, text: "41 %", disabled: false },
  { value: 42, text: "42 %", disabled: false },
  { value: 43, text: "43 %", disabled: false },
  { value: 44, text: "44 %", disabled: false },
  { value: 45, text: "45 %", disabled: false },
  { value: 46, text: "46 %", disabled: false },
  { value: 47, text: "47 %", disabled: false },
  { value: 48, text: "48 %", disabled: false },
  { value: 49, text: "49 %", disabled: false },
  { value: 50, text: "50 %", disabled: false },
  { value: 51, text: "51 %", disabled: false },
  { value: 52, text: "52 %", disabled: false },
  { value: 53, text: "53 %", disabled: false },
  { value: 54, text: "54 %", disabled: false },
  { value: 55, text: "55 %", disabled: false },
  { value: 56, text: "56 %", disabled: false },
  { value: 57, text: "57 %", disabled: false },
  { value: 58, text: "58 %", disabled: false },
  { value: 59, text: "59 %", disabled: false },
  { value: 60, text: "60 %", disabled: false },
  { value: 61, text: "61 %", disabled: false },
  { value: 62, text: "62 %", disabled: false },
  { value: 63, text: "63 %", disabled: false },
  { value: 64, text: "64 %", disabled: false },
  { value: 65, text: "65 %", disabled: false },
  { value: 66, text: "66 %", disabled: false },
  { value: 67, text: "67 %", disabled: false },
  { value: 68, text: "68 %", disabled: false },
  { value: 69, text: "69 %", disabled: false },
  { value: 70, text: "70 %", disabled: false },
  { value: 71, text: "71 %", disabled: false },
  { value: 72, text: "72 %", disabled: false },
  { value: 73, text: "73 %", disabled: false },
  { value: 74, text: "74 %", disabled: false },
  { value: 75, text: "75 %", disabled: false },
  { value: 76, text: "76 %", disabled: false },
  { value: 77, text: "77 %", disabled: false },
  { value: 78, text: "78 %", disabled: false },
  { value: 79, text: "79 %", disabled: false },
  { value: 70, text: "80 %", disabled: false },
  { value: 81, text: "81 %", disabled: false },
  { value: 82, text: "82 %", disabled: false },
  { value: 83, text: "83 %", disabled: false },
  { value: 84, text: "84 %", disabled: false },
  { value: 85, text: "85 %", disabled: false },
  { value: 86, text: "86 %", disabled: false },
  { value: 87, text: "87 %", disabled: false },
  { value: 88, text: "88 %", disabled: false },
  { value: 89, text: "89 %", disabled: false },
  { value: 90, text: "90 %", disabled: false },
  { value: 91, text: "91 %", disabled: false },
  { value: 92, text: "92 %", disabled: false },
  { value: 93, text: "93 %", disabled: false },
  { value: 94, text: "94 %", disabled: false },
  { value: 95, text: "95 %", disabled: false },
  { value: 96, text: "96 %", disabled: false },
  { value: 97, text: "97 %", disabled: false },
  { value: 98, text: "98 %", disabled: false },
  { value: 99, text: "99 %", disabled: false },
  { value: 100, text: "100 %", disabled: false },
];

export const when_to_authorize = [
  { value: 0, text: "Immediately", disabled: false },
  { value: 3600, text: "1 Hour", disabled: false },
  { value: 7200, text: "2 Hours", disabled: false },
  { value: 10800, text: "3 Hours", disabled: false },
  { value: 14400, text: "4 Hours", disabled: false },
  { value: 18000, text: "5 Hours", disabled: false },
  { value: 21600, text: "6 Hours", disabled: false },
  { value: 25200, text: "7 Hours", disabled: false },
  { value: 28800, text: "8 Hours", disabled: false },
  { value: 32400, text: "9 Hours", disabled: false },
  { value: 36000, text: "10 Hours", disabled: false },
  { value: 39600, text: "11 Hours", disabled: false },
  { value: 43200, text: "12 Hours", disabled: false },
  { value: 46800, text: "13 Hours", disabled: false },
  { value: 50400, text: "14 Hours", disabled: false },
  { value: 54000, text: "15 Hours", disabled: false },
  { value: 57600, text: "16 Hours", disabled: false },
  { value: 61200, text: "17 Hours", disabled: false },
  { value: 64800, text: "18 Hours", disabled: false },
  { value: 68400, text: "19 Hours", disabled: false },
  { value: 72000, text: "20 Hours", disabled: false },
  { value: 75600, text: "21 Hours", disabled: false },
  { value: 79200, text: "22 Hours", disabled: false },
  { value: 82800, text: "23 Hours", disabled: false },
  { value: 86400, text: "1 day", disabled: false },
  { value: 172800, text: "2 days", disabled: false },
  { value: 259200, text: "3 days", disabled: false },
  { value: 345600, text: "4 days", disabled: false },
  { value: 432000, text: "5 days", disabled: false },
  { value: 518400, text: "6 days", disabled: false },
  { value: 604800, text: "7 days", disabled: false },
  { value: 691200, text: "8 days", disabled: false },
  { value: 777600, text: "9 days", disabled: false },
  { value: 864000, text: "10 days", disabled: false },
  { value: 950400, text: "11 days", disabled: false },
  { value: 1036800, text: "12 days", disabled: false },
  { value: 1123200, text: "13 days", disabled: false },
  { value: 1209600, text: "14 days", disabled: false },
  { value: 1296000, text: "15 days", disabled: false },
  { value: 1382400, text: "16 days", disabled: false },
  { value: 1468800, text: "17 days", disabled: false },
  { value: 1555200, text: "18 days", disabled: false },
  { value: 1641600, text: "19 days", disabled: false },
  { value: 1728000, text: "20 days", disabled: false },
  { value: 1814400, text: "21 days", disabled: false },
  { value: 1900800, text: "22 days", disabled: false },
  { value: 1987200, text: "23 days", disabled: false },
  { value: 2073600, text: "24 days", disabled: false },
  { value: 2160000, text: "25 days", disabled: false },
  { value: 2246400, text: "26 days", disabled: false },
  { value: 2332800, text: "27 days", disabled: false },
  { value: 2419200, text: "28 days", disabled: false },
  { value: 2505600, text: "29 days", disabled: false },
  { value: 2592000, text: "30 days", disabled: false },
  { value: 2678400, text: "31 days", disabled: false },
  { value: 2764800, text: "32 days", disabled: false },
  { value: 2851200, text: "33 days", disabled: false },
  { value: 2937600, text: "34 days", disabled: false },
  { value: 3024000, text: "35 days", disabled: false },
  { value: 3110400, text: "36 days", disabled: false },
  { value: 3196800, text: "37 days", disabled: false },
  { value: 3283200, text: "38 days", disabled: false },
  { value: 3369600, text: "39 days", disabled: false },
  { value: 3456000, text: "40 days", disabled: false },
  { value: 3542400, text: "41 days", disabled: false },
  { value: 3628800, text: "42 days", disabled: false },
  { value: 3715200, text: "43 days", disabled: false },
  { value: 3801600, text: "44 days", disabled: false },
  { value: 3888000, text: "45 days", disabled: false },
  { value: 3974400, text: "46 days", disabled: false },
  { value: 4060800, text: "47 days", disabled: false },
  { value: 4147200, text: "48 days", disabled: false },
  { value: 4233600, text: "49 days", disabled: false },
  { value: 4320000, text: "50 days", disabled: false },
  { value: 4406400, text: "51 days", disabled: false },
  { value: 4492800, text: "52 days", disabled: false },
  { value: 4579200, text: "53 days", disabled: false },
  { value: 4665600, text: "54 days", disabled: false },
  { value: 4752000, text: "55 days", disabled: false },
  { value: 4838400, text: "56 days", disabled: false },
  { value: 4924800, text: "57 days", disabled: false },
  { value: 5011200, text: "58 days", disabled: false },
  { value: 5097600, text: "59 days", disabled: false },
  { value: 5184000, text: "60 days", disabled: false },
  { value: 5270400, text: "61 days", disabled: false },
  { value: 5356800, text: "62 days", disabled: false },
  { value: 5443200, text: "63 days", disabled: false },
  { value: 5529600, text: "64 days", disabled: false },
  { value: 5616000, text: "65 days", disabled: false },
  { value: 5702400, text: "66 days", disabled: false },
  { value: 5788800, text: "67 days", disabled: false },
  { value: 5875200, text: "68 days", disabled: false },
  { value: 5961600, text: "69 days", disabled: false },
  { value: 6048000, text: "70 days", disabled: false },
  { value: 6134400, text: "71 days", disabled: false },
  { value: 6220800, text: "72 days", disabled: false },
  { value: 6307200, text: "73 days", disabled: false },
  { value: 6393600, text: "74 days", disabled: false },
  { value: 6480000, text: "75 days", disabled: false },
  { value: 6566400, text: "76 days", disabled: false },
  { value: 6652800, text: "77 days", disabled: false },
  { value: 6739200, text: "78 days", disabled: false },
  { value: 6825600, text: "79 days", disabled: false },
  { value: 6912000, text: "80 days", disabled: false },
  { value: 6998400, text: "81 days", disabled: false },
  { value: 7084800, text: "82 days", disabled: false },
  { value: 7171200, text: "83 days", disabled: false },
  { value: 7257600, text: "84 days", disabled: false },
  { value: 7344000, text: "85 days", disabled: false },
  { value: 7430400, text: "86 days", disabled: false },
  { value: 7516800, text: "87 days", disabled: false },
  { value: 7603200, text: "88 days", disabled: false },
  { value: 7689600, text: "89 days", disabled: false },
  { value: 7776000, text: "90 days", disabled: false },
  { value: 7862400, text: "91 days", disabled: false },
  { value: 7948800, text: "92 days", disabled: false },
  { value: 8035200, text: "93 days", disabled: false },
  { value: 8121600, text: "94 days", disabled: false },
  { value: 8208000, text: "95 days", disabled: false },
  { value: 8294400, text: "96 days", disabled: false },
  { value: 8380800, text: "97 days", disabled: false },
  { value: 8467200, text: "98 days", disabled: false },
  { value: 8553600, text: "99 days", disabled: false },
  { value: 8640000, text: "100 days", disabled: false },
  { value: 8726400, text: "101 days", disabled: false },
  { value: 8812800, text: "102 days", disabled: false },
  { value: 8899200, text: "103 days", disabled: false },
  { value: 8985600, text: "104 days", disabled: false },
  { value: 9072000, text: "105 days", disabled: false },
  { value: 9158400, text: "106 days", disabled: false },
  { value: 9244800, text: "107 days", disabled: false },
  { value: 9331200, text: "108 days", disabled: false },
  { value: 9417600, text: "109 days", disabled: false },
  { value: 9504000, text: "110 days", disabled: false },
  { value: 9590400, text: "111 days", disabled: false },
  { value: 9676800, text: "112 days", disabled: false },
  { value: 9763200, text: "113 days", disabled: false },
  { value: 9849600, text: "114 days", disabled: false },
  { value: 9936000, text: "115 days", disabled: false },
  { value: 10022400, text: "116 days", disabled: false },
  { value: 10108800, text: "117 days", disabled: false },
  { value: 10195200, text: "118 days", disabled: false },
  { value: 10281600, text: "119 days", disabled: false },
  { value: 10368000, text: "120 days", disabled: false },
  { value: 10454400, text: "121 days", disabled: false },
  { value: 10540800, text: "122 days", disabled: false },
  { value: 10627200, text: "123 days", disabled: false },
  { value: 10713600, text: "124 days", disabled: false },
  { value: 10800000, text: "125 days", disabled: false },
  { value: 10886400, text: "126 days", disabled: false },
  { value: 10972800, text: "127 days", disabled: false },
  { value: 11059200, text: "128 days", disabled: false },
  { value: 11145600, text: "129 days", disabled: false },
  { value: 11232000, text: "130 days", disabled: false },
  { value: 11318400, text: "131 days", disabled: false },
  { value: 11404800, text: "132 days", disabled: false },
  { value: 11491200, text: "133 days", disabled: false },
  { value: 11577600, text: "134 days", disabled: false },
  { value: 11664000, text: "135 days", disabled: false },
  { value: 11750400, text: "136 days", disabled: false },
  { value: 11836800, text: "137 days", disabled: false },
  { value: 11923200, text: "138 days", disabled: false },
  { value: 12009600, text: "139 days", disabled: false },
  { value: 12096000, text: "140 days", disabled: false },
  { value: 12182400, text: "141 days", disabled: false },
  { value: 12268800, text: "142 days", disabled: false },
  { value: 12355200, text: "143 days", disabled: false },
  { value: 12441600, text: "144 days", disabled: false },
  { value: 12528000, text: "145 days", disabled: false },
  { value: 12614400, text: "146 days", disabled: false },
  { value: 12700800, text: "147 days", disabled: false },
  { value: 12787200, text: "148 days", disabled: false },
  { value: 12873600, text: "149 days", disabled: false },
  { value: 12960000, text: "150 days", disabled: false },
  { value: 13046400, text: "151 days", disabled: false },
  { value: 13132800, text: "152 days", disabled: false },
  { value: 13219200, text: "153 days", disabled: false },
  { value: 13305600, text: "154 days", disabled: false },
  { value: 13392000, text: "155 days", disabled: false },
  { value: 13478400, text: "156 days", disabled: false },
  { value: 13564800, text: "157 days", disabled: false },
  { value: 13651200, text: "158 days", disabled: false },
  { value: 13737600, text: "159 days", disabled: false },
  { value: 13824000, text: "160 days", disabled: false },
  { value: 13910400, text: "161 days", disabled: false },
  { value: 13996800, text: "162 days", disabled: false },
  { value: 14083200, text: "163 days", disabled: false },
  { value: 14169600, text: "164 days", disabled: false },
  { value: 14256000, text: "165 days", disabled: false },
  { value: 14342400, text: "166 days", disabled: false },
  { value: 14428800, text: "167 days", disabled: false },
  { value: 14515200, text: "168 days", disabled: false },
  { value: 14601600, text: "169 days", disabled: false },
  { value: 14688000, text: "170 days", disabled: false },
  { value: 14774400, text: "171 days", disabled: false },
  { value: 14860800, text: "172 days", disabled: false },
  { value: 14947200, text: "173 days", disabled: false },
  { value: 15033600, text: "174 days", disabled: false },
  { value: 15120000, text: "175 days", disabled: false },
  { value: 15206400, text: "176 days", disabled: false },
  { value: 15292800, text: "177 days", disabled: false },
  { value: 15379200, text: "178 days", disabled: false },
  { value: 15465600, text: "179 days", disabled: false },
  { value: 15552000, text: "180 days", disabled: false },
  { value: 15638400, text: "181 days", disabled: false },
  { value: 15724800, text: "182 days", disabled: false },
  { value: 15811200, text: "183 days", disabled: false },
  { value: 15897600, text: "184 days", disabled: false },
  { value: 15984000, text: "185 days", disabled: false },
  { value: 16070400, text: "186 days", disabled: false },
  { value: 16156800, text: "187 days", disabled: false },
  { value: 16243200, text: "188 days", disabled: false },
  { value: 16329600, text: "189 days", disabled: false },
  { value: 16416000, text: "190 days", disabled: false },
  { value: 16502400, text: "191 days", disabled: false },
  { value: 16588800, text: "192 days", disabled: false },
  { value: 16675200, text: "193 days", disabled: false },
  { value: 16761600, text: "194 days", disabled: false },
  { value: 16848000, text: "195 days", disabled: false },
  { value: 16934400, text: "196 days", disabled: false },
  { value: 17020800, text: "197 days", disabled: false },
  { value: 17107200, text: "198 days", disabled: false },
  { value: 17193600, text: "199 days", disabled: false },
  { value: 17280000, text: "200 days", disabled: false },
  { value: 17366400, text: "201 days", disabled: false },
  { value: 17452800, text: "202 days", disabled: false },
  { value: 17539200, text: "203 days", disabled: false },
  { value: 17625600, text: "204 days", disabled: false },
  { value: 17712000, text: "205 days", disabled: false },
  { value: 17798400, text: "206 days", disabled: false },
  { value: 17884800, text: "207 days", disabled: false },
  { value: 17971200, text: "208 days", disabled: false },
  { value: 18057600, text: "209 days", disabled: false },
  { value: 18144000, text: "210 days", disabled: false },
  { value: 18230400, text: "211 days", disabled: false },
  { value: 18316800, text: "212 days", disabled: false },
  { value: 18403200, text: "213 days", disabled: false },
  { value: 18489600, text: "214 days", disabled: false },
  { value: 18576000, text: "215 days", disabled: false },
  { value: 18662400, text: "216 days", disabled: false },
  { value: 18748800, text: "217 days", disabled: false },
  { value: 18835200, text: "218 days", disabled: false },
  { value: 18921600, text: "219 days", disabled: false },
  { value: 19008000, text: "220 days", disabled: false },
  { value: 19094400, text: "221 days", disabled: false },
  { value: 19180800, text: "222 days", disabled: false },
  { value: 19267200, text: "223 days", disabled: false },
  { value: 19353600, text: "224 days", disabled: false },
  { value: 19440000, text: "225 days", disabled: false },
  { value: 19526400, text: "226 days", disabled: false },
  { value: 19612800, text: "227 days", disabled: false },
  { value: 19699200, text: "228 days", disabled: false },
  { value: 19785600, text: "229 days", disabled: false },
  { value: 19872000, text: "230 days", disabled: false },
  { value: 19958400, text: "231 days", disabled: false },
  { value: 20044800, text: "232 days", disabled: false },
  { value: 20131200, text: "233 days", disabled: false },
  { value: 20217600, text: "234 days", disabled: false },
  { value: 20304000, text: "235 days", disabled: false },
  { value: 20390400, text: "236 days", disabled: false },
  { value: 20476800, text: "237 days", disabled: false },
  { value: 20563200, text: "238 days", disabled: false },
  { value: 20649600, text: "239 days", disabled: false },
  { value: 20736000, text: "240 days", disabled: false },
  { value: 20822400, text: "241 days", disabled: false },
  { value: 20908800, text: "242 days", disabled: false },
  { value: 20995200, text: "243 days", disabled: false },
  { value: 21081600, text: "244 days", disabled: false },
  { value: 21168000, text: "245 days", disabled: false },
  { value: 21254400, text: "246 days", disabled: false },
  { value: 21340800, text: "247 days", disabled: false },
  { value: 21427200, text: "248 days", disabled: false },
  { value: 21513600, text: "249 days", disabled: false },
  { value: 21600000, text: "250 days", disabled: false },
  { value: 21686400, text: "251 days", disabled: false },
  { value: 21772800, text: "252 days", disabled: false },
  { value: 21859200, text: "253 days", disabled: false },
  { value: 21945600, text: "254 days", disabled: false },
  { value: 22032000, text: "255 days", disabled: false },
  { value: 22118400, text: "256 days", disabled: false },
  { value: 22204800, text: "257 days", disabled: false },
  { value: 22291200, text: "258 days", disabled: false },
  { value: 22377600, text: "259 days", disabled: false },
  { value: 22464000, text: "260 days", disabled: false },
  { value: 22550400, text: "261 days", disabled: false },
  { value: 22636800, text: "262 days", disabled: false },
  { value: 22723200, text: "263 days", disabled: false },
  { value: 22809600, text: "264 days", disabled: false },
  { value: 22896000, text: "265 days", disabled: false },
  { value: 22982400, text: "266 days", disabled: false },
  { value: 23068800, text: "267 days", disabled: false },
  { value: 23155200, text: "268 days", disabled: false },
  { value: 23241600, text: "269 days", disabled: false },
  { value: 23328000, text: "270 days", disabled: false },
  { value: 23414400, text: "271 days", disabled: false },
  { value: 23500800, text: "272 days", disabled: false },
  { value: 23587200, text: "273 days", disabled: false },
  { value: 23673600, text: "274 days", disabled: false },
  { value: 23760000, text: "275 days", disabled: false },
  { value: 23846400, text: "276 days", disabled: false },
  { value: 23932800, text: "277 days", disabled: false },
  { value: 24019200, text: "278 days", disabled: false },
  { value: 24105600, text: "279 days", disabled: false },
  { value: 24192000, text: "280 days", disabled: false },
  { value: 24278400, text: "281 days", disabled: false },
  { value: 24364800, text: "282 days", disabled: false },
  { value: 24451200, text: "283 days", disabled: false },
  { value: 24537600, text: "284 days", disabled: false },
  { value: 24624000, text: "285 days", disabled: false },
  { value: 24710400, text: "286 days", disabled: false },
  { value: 24796800, text: "287 days", disabled: false },
  { value: 24883200, text: "288 days", disabled: false },
  { value: 24969600, text: "289 days", disabled: false },
  { value: 25056000, text: "290 days", disabled: false },
  { value: 25142400, text: "291 days", disabled: false },
  { value: 25228800, text: "292 days", disabled: false },
  { value: 25315200, text: "293 days", disabled: false },
  { value: 25401600, text: "294 days", disabled: false },
  { value: 25488000, text: "295 days", disabled: false },
  { value: 25574400, text: "296 days", disabled: false },
  { value: 25660800, text: "297 days", disabled: false },
  { value: 25747200, text: "298 days", disabled: false },
  { value: 25833600, text: "299 days", disabled: false },
  { value: 25920000, text: "300 days", disabled: false },
  { value: 26006400, text: "301 days", disabled: false },
  { value: 26092800, text: "302 days", disabled: false },
  { value: 26179200, text: "303 days", disabled: false },
  { value: 26265600, text: "304 days", disabled: false },
  { value: 26352000, text: "305 days", disabled: false },
  { value: 26438400, text: "306 days", disabled: false },
  { value: 26524800, text: "307 days", disabled: false },
  { value: 26611200, text: "308 days", disabled: false },
  { value: 26697600, text: "309 days", disabled: false },
  { value: 26784000, text: "310 days", disabled: false },
  { value: 26870400, text: "311 days", disabled: false },
  { value: 26956800, text: "312 days", disabled: false },
  { value: 27043200, text: "313 days", disabled: false },
  { value: 27129600, text: "314 days", disabled: false },
  { value: 27216000, text: "315 days", disabled: false },
  { value: 27302400, text: "316 days", disabled: false },
  { value: 27388800, text: "317 days", disabled: false },
  { value: 27475200, text: "318 days", disabled: false },
  { value: 27561600, text: "319 days", disabled: false },
  { value: 27648000, text: "320 days", disabled: false },
  { value: 27734400, text: "321 days", disabled: false },
  { value: 27820800, text: "322 days", disabled: false },
  { value: 27907200, text: "323 days", disabled: false },
  { value: 27993600, text: "324 days", disabled: false },
  { value: 28080000, text: "325 days", disabled: false },
  { value: 28166400, text: "326 days", disabled: false },
  { value: 28252800, text: "327 days", disabled: false },
  { value: 28339200, text: "328 days", disabled: false },
  { value: 28425600, text: "329 days", disabled: false },
  { value: 28512000, text: "330 days", disabled: false },
  { value: 28598400, text: "331 days", disabled: false },
  { value: 28684800, text: "332 days", disabled: false },
  { value: 28771200, text: "333 days", disabled: false },
  { value: 28857600, text: "334 days", disabled: false },
  { value: 28944000, text: "335 days", disabled: false },
  { value: 29030400, text: "336 days", disabled: false },
  { value: 29116800, text: "337 days", disabled: false },
  { value: 29203200, text: "338 days", disabled: false },
  { value: 29289600, text: "339 days", disabled: false },
  { value: 29376000, text: "340 days", disabled: false },
  { value: 29462400, text: "341 days", disabled: false },
  { value: 29548800, text: "342 days", disabled: false },
  { value: 29635200, text: "343 days", disabled: false },
  { value: 29721600, text: "344 days", disabled: false },
  { value: 29808000, text: "345 days", disabled: false },
  { value: 29894400, text: "346 days", disabled: false },
  { value: 29980800, text: "347 days", disabled: false },
  { value: 30067200, text: "348 days", disabled: false },
  { value: 30153600, text: "349 days", disabled: false },
  { value: 30240000, text: "350 days", disabled: false },
  { value: 30326400, text: "351 days", disabled: false },
  { value: 30412800, text: "352 days", disabled: false },
  { value: 30499200, text: "353 days", disabled: false },
  { value: 30585600, text: "354 days", disabled: false },
  { value: 30672000, text: "355 days", disabled: false },
  { value: 30758400, text: "356 days", disabled: false },
  { value: 30844800, text: "357 days", disabled: false },
  { value: 30931200, text: "358 days", disabled: false },
  { value: 31017600, text: "359 days", disabled: false },
  { value: 31104000, text: "360 days", disabled: false },
  { value: 31190400, text: "361 days", disabled: false },
  { value: 31276800, text: "362 days", disabled: false },
  { value: 31363200, text: "363 days", disabled: false },
  { value: 31449600, text: "364 days", disabled: false },
  { value: 31536000, text: "365 days", disabled: false },
];

export const cancellation_fee_within = [
  { value: 0, text: "Immediately", disabled: false },
  { value: 3600, text: "More than 1 Hour", disabled: false },
  { value: 7200, text: "More than 2 Hours", disabled: false },
  { value: 10800, text: "More than 3 Hours", disabled: false },
  { value: 14400, text: "More than 4 Hours", disabled: false },
  { value: 18000, text: "More than 5 Hours", disabled: false },
  { value: 21600, text: "More than 6 Hours", disabled: false },
  { value: 25200, text: "More than 7 Hours", disabled: false },
  { value: 28800, text: "More than 8 Hours", disabled: false },
  { value: 32400, text: "More than 9 Hours", disabled: false },
  { value: 36000, text: "More than 10 Hours", disabled: false },
  { value: 39600, text: "More than 11 Hours", disabled: false },
  { value: 43200, text: "More than 12 Hours", disabled: false },
  { value: 46800, text: "More than 13 Hours", disabled: false },
  { value: 50400, text: "More than 14 Hours", disabled: false },
  { value: 54000, text: "More than 15 Hours", disabled: false },
  { value: 57600, text: "More than 16 Hours", disabled: false },
  { value: 61200, text: "More than 17 Hours", disabled: false },
  { value: 64800, text: "More than 18 Hours", disabled: false },
  { value: 68400, text: "More than 19 Hours", disabled: false },
  { value: 72000, text: "More than 20 Hours", disabled: false },
  { value: 75600, text: "More than 21 Hours", disabled: false },
  { value: 79200, text: "More than 22 Hours", disabled: false },
  { value: 82800, text: "More than 23 Hours", disabled: false },
  { value: 86400, text: "More than 1 day", disabled: false },
  { value: 172800, text: "More than 2 days", disabled: false },
  { value: 259200, text: "More than 3 days", disabled: false },
  { value: 345600, text: "More than 4 days", disabled: false },
  { value: 432000, text: "More than 5 days", disabled: false },
  { value: 518400, text: "More than 6 days", disabled: false },
  { value: 604800, text: "More than 7 days", disabled: false },
  { value: 691200, text: "More than 8 days", disabled: false },
  { value: 777600, text: "More than 9 days", disabled: false },
  { value: 864000, text: "More than 10 days", disabled: false },
  { value: 950400, text: "More than 11 days", disabled: false },
  { value: 1036800, text: "More than 12 days", disabled: false },
  { value: 1123200, text: "More than 13 days", disabled: false },
  { value: 1209600, text: "More than 14 days", disabled: false },
  { value: 1296000, text: "More than 15 days", disabled: false },
  { value: 1382400, text: "More than 16 days", disabled: false },
  { value: 1468800, text: "More than 17 days", disabled: false },
  { value: 1555200, text: "More than 18 days", disabled: false },
  { value: 1641600, text: "More than 19 days", disabled: false },
  { value: 1728000, text: "More than 20 days", disabled: false },
  { value: 1814400, text: "More than 21 days", disabled: false },
  { value: 1900800, text: "More than 22 days", disabled: false },
  { value: 1987200, text: "More than 23 days", disabled: false },
  { value: 2073600, text: "More than 24 days", disabled: false },
  { value: 2160000, text: "More than 25 days", disabled: false },
  { value: 2246400, text: "More than 26 days", disabled: false },
  { value: 2332800, text: "More than 27 days", disabled: false },
  { value: 2419200, text: "More than 28 days", disabled: false },
  { value: 2505600, text: "More than 29 days", disabled: false },
  { value: 2592000, text: "More than 30 days", disabled: false },
  { value: 2678400, text: "More than 31 days", disabled: false },
  { value: 2764800, text: "More than 32 days", disabled: false },
  { value: 2851200, text: "More than 33 days", disabled: false },
  { value: 2937600, text: "More than 34 days", disabled: false },
  { value: 3024000, text: "More than 35 days", disabled: false },
  { value: 3110400, text: "More than 36 days", disabled: false },
  { value: 3196800, text: "More than 37 days", disabled: false },
  { value: 3283200, text: "More than 38 days", disabled: false },
  { value: 3369600, text: "More than 39 days", disabled: false },
  { value: 3456000, text: "More than 40 days", disabled: false },
  { value: 3542400, text: "More than 41 days", disabled: false },
  { value: 3628800, text: "More than 42 days", disabled: false },
  { value: 3715200, text: "More than 43 days", disabled: false },
  { value: 3801600, text: "More than 44 days", disabled: false },
  { value: 3888000, text: "More than 45 days", disabled: false },
  { value: 3974400, text: "More than 46 days", disabled: false },
  { value: 4060800, text: "More than 47 days", disabled: false },
  { value: 4147200, text: "More than 48 days", disabled: false },
  { value: 4233600, text: "More than 49 days", disabled: false },
  { value: 4320000, text: "More than 50 days", disabled: false },
  { value: 4406400, text: "More than 51 days", disabled: false },
  { value: 4492800, text: "More than 52 days", disabled: false },
  { value: 4579200, text: "More than 53 days", disabled: false },
  { value: 4665600, text: "More than 54 days", disabled: false },
  { value: 4752000, text: "More than 55 days", disabled: false },
  { value: 4838400, text: "More than 56 days", disabled: false },
  { value: 4924800, text: "More than 57 days", disabled: false },
  { value: 5011200, text: "More than 58 days", disabled: false },
  { value: 5097600, text: "More than 59 days", disabled: false },
  { value: 5184000, text: "More than 60 days", disabled: false },
  { value: 5270400, text: "More than 61 days", disabled: false },
  { value: 5356800, text: "More than 62 days", disabled: false },
  { value: 5443200, text: "More than 63 days", disabled: false },
  { value: 5529600, text: "More than 64 days", disabled: false },
  { value: 5616000, text: "More than 65 days", disabled: false },
  { value: 5702400, text: "More than 66 days", disabled: false },
  { value: 5788800, text: "More than 67 days", disabled: false },
  { value: 5875200, text: "More than 68 days", disabled: false },
  { value: 5961600, text: "More than 69 days", disabled: false },
  { value: 6048000, text: "More than 70 days", disabled: false },
  { value: 6134400, text: "More than 71 days", disabled: false },
  { value: 6220800, text: "More than 72 days", disabled: false },
  { value: 6307200, text: "More than 73 days", disabled: false },
  { value: 6393600, text: "More than 74 days", disabled: false },
  { value: 6480000, text: "More than 75 days", disabled: false },
  { value: 6566400, text: "More than 76 days", disabled: false },
  { value: 6652800, text: "More than 77 days", disabled: false },
  { value: 6739200, text: "More than 78 days", disabled: false },
  { value: 6825600, text: "More than 79 days", disabled: false },
  { value: 6912000, text: "More than 80 days", disabled: false },
  { value: 6998400, text: "More than 81 days", disabled: false },
  { value: 7084800, text: "More than 82 days", disabled: false },
  { value: 7171200, text: "More than 83 days", disabled: false },
  { value: 7257600, text: "More than 84 days", disabled: false },
  { value: 7344000, text: "More than 85 days", disabled: false },
  { value: 7430400, text: "More than 86 days", disabled: false },
  { value: 7516800, text: "More than 87 days", disabled: false },
  { value: 7603200, text: "More than 88 days", disabled: false },
  { value: 7689600, text: "More than 89 days", disabled: false },
  { value: 7776000, text: "More than 90 days", disabled: false },
  { value: 7862400, text: "More than 91 days", disabled: false },
  { value: 7948800, text: "More than 92 days", disabled: false },
  { value: 8035200, text: "More than 93 days", disabled: false },
  { value: 8121600, text: "More than 94 days", disabled: false },
  { value: 8208000, text: "More than 95 days", disabled: false },
  { value: 8294400, text: "More than 96 days", disabled: false },
  { value: 8380800, text: "More than 97 days", disabled: false },
  { value: 8467200, text: "More than 98 days", disabled: false },
  { value: 8553600, text: "More than 99 days", disabled: false },
  { value: 8640000, text: "More than 100 days", disabled: false },
  { value: 8726400, text: "More than 101 days", disabled: false },
  { value: 8812800, text: "More than 102 days", disabled: false },
  { value: 8899200, text: "More than 103 days", disabled: false },
  { value: 8985600, text: "More than 104 days", disabled: false },
  { value: 9072000, text: "More than 105 days", disabled: false },
  { value: 9158400, text: "More than 106 days", disabled: false },
  { value: 9244800, text: "More than 107 days", disabled: false },
  { value: 9331200, text: "More than 108 days", disabled: false },
  { value: 9417600, text: "More than 109 days", disabled: false },
  { value: 9504000, text: "More than 110 days", disabled: false },
  { value: 9590400, text: "More than 111 days", disabled: false },
  { value: 9676800, text: "More than 112 days", disabled: false },
  { value: 9763200, text: "More than 113 days", disabled: false },
  { value: 9849600, text: "More than 114 days", disabled: false },
  { value: 9936000, text: "More than 115 days", disabled: false },
  { value: 10022400, text: "More than 116 days", disabled: false },
  { value: 10108800, text: "More than 117 days", disabled: false },
  { value: 10195200, text: "More than 118 days", disabled: false },
  { value: 10281600, text: "More than 119 days", disabled: false },
  { value: 10368000, text: "More than 120 days", disabled: false },
  { value: 10454400, text: "More than 121 days", disabled: false },
  { value: 10540800, text: "More than 122 days", disabled: false },
  { value: 10627200, text: "More than 123 days", disabled: false },
  { value: 10713600, text: "More than 124 days", disabled: false },
  { value: 10800000, text: "More than 125 days", disabled: false },
  { value: 10886400, text: "More than 126 days", disabled: false },
  { value: 10972800, text: "More than 127 days", disabled: false },
  { value: 11059200, text: "More than 128 days", disabled: false },
  { value: 11145600, text: "More than 129 days", disabled: false },
  { value: 11232000, text: "More than 130 days", disabled: false },
  { value: 11318400, text: "More than 131 days", disabled: false },
  { value: 11404800, text: "More than 132 days", disabled: false },
  { value: 11491200, text: "More than 133 days", disabled: false },
  { value: 11577600, text: "More than 134 days", disabled: false },
  { value: 11664000, text: "More than 135 days", disabled: false },
  { value: 11750400, text: "More than 136 days", disabled: false },
  { value: 11836800, text: "More than 137 days", disabled: false },
  { value: 11923200, text: "More than 138 days", disabled: false },
  { value: 12009600, text: "More than 139 days", disabled: false },
  { value: 12096000, text: "More than 140 days", disabled: false },
  { value: 12182400, text: "More than 141 days", disabled: false },
  { value: 12268800, text: "More than 142 days", disabled: false },
  { value: 12355200, text: "More than 143 days", disabled: false },
  { value: 12441600, text: "More than 144 days", disabled: false },
  { value: 12528000, text: "More than 145 days", disabled: false },
  { value: 12614400, text: "More than 146 days", disabled: false },
  { value: 12700800, text: "More than 147 days", disabled: false },
  { value: 12787200, text: "More than 148 days", disabled: false },
  { value: 12873600, text: "More than 149 days", disabled: false },
  { value: 12960000, text: "More than 150 days", disabled: false },
  { value: 13046400, text: "More than 151 days", disabled: false },
  { value: 13132800, text: "More than 152 days", disabled: false },
  { value: 13219200, text: "More than 153 days", disabled: false },
  { value: 13305600, text: "More than 154 days", disabled: false },
  { value: 13392000, text: "More than 155 days", disabled: false },
  { value: 13478400, text: "More than 156 days", disabled: false },
  { value: 13564800, text: "More than 157 days", disabled: false },
  { value: 13651200, text: "More than 158 days", disabled: false },
  { value: 13737600, text: "More than 159 days", disabled: false },
  { value: 13824000, text: "More than 160 days", disabled: false },
  { value: 13910400, text: "More than 161 days", disabled: false },
  { value: 13996800, text: "More than 162 days", disabled: false },
  { value: 14083200, text: "More than 163 days", disabled: false },
  { value: 14169600, text: "More than 164 days", disabled: false },
  { value: 14256000, text: "More than 165 days", disabled: false },
  { value: 14342400, text: "More than 166 days", disabled: false },
  { value: 14428800, text: "More than 167 days", disabled: false },
  { value: 14515200, text: "More than 168 days", disabled: false },
  { value: 14601600, text: "More than 169 days", disabled: false },
  { value: 14688000, text: "More than 170 days", disabled: false },
  { value: 14774400, text: "More than 171 days", disabled: false },
  { value: 14860800, text: "More than 172 days", disabled: false },
  { value: 14947200, text: "More than 173 days", disabled: false },
  { value: 15033600, text: "More than 174 days", disabled: false },
  { value: 15120000, text: "More than 175 days", disabled: false },
  { value: 15206400, text: "More than 176 days", disabled: false },
  { value: 15292800, text: "More than 177 days", disabled: false },
  { value: 15379200, text: "More than 178 days", disabled: false },
  { value: 15465600, text: "More than 179 days", disabled: false },
  { value: 15552000, text: "More than 180 days", disabled: false },
  { value: 15638400, text: "More than 181 days", disabled: false },
  { value: 15724800, text: "More than 182 days", disabled: false },
  { value: 15811200, text: "More than 183 days", disabled: false },
  { value: 15897600, text: "More than 184 days", disabled: false },
  { value: 15984000, text: "More than 185 days", disabled: false },
  { value: 16070400, text: "More than 186 days", disabled: false },
  { value: 16156800, text: "More than 187 days", disabled: false },
  { value: 16243200, text: "More than 188 days", disabled: false },
  { value: 16329600, text: "More than 189 days", disabled: false },
  { value: 16416000, text: "More than 190 days", disabled: false },
  { value: 16502400, text: "More than 191 days", disabled: false },
  { value: 16588800, text: "More than 192 days", disabled: false },
  { value: 16675200, text: "More than 193 days", disabled: false },
  { value: 16761600, text: "More than 194 days", disabled: false },
  { value: 16848000, text: "More than 195 days", disabled: false },
  { value: 16934400, text: "More than 196 days", disabled: false },
  { value: 17020800, text: "More than 197 days", disabled: false },
  { value: 17107200, text: "More than 198 days", disabled: false },
  { value: 17193600, text: "More than 199 days", disabled: false },
  { value: 17280000, text: "More than 200 days", disabled: false },
  { value: 17366400, text: "More than 201 days", disabled: false },
  { value: 17452800, text: "More than 202 days", disabled: false },
  { value: 17539200, text: "More than 203 days", disabled: false },
  { value: 17625600, text: "More than 204 days", disabled: false },
  { value: 17712000, text: "More than 205 days", disabled: false },
  { value: 17798400, text: "More than 206 days", disabled: false },
  { value: 17884800, text: "More than 207 days", disabled: false },
  { value: 17971200, text: "More than 208 days", disabled: false },
  { value: 18057600, text: "More than 209 days", disabled: false },
  { value: 18144000, text: "More than 210 days", disabled: false },
  { value: 18230400, text: "More than 211 days", disabled: false },
  { value: 18316800, text: "More than 212 days", disabled: false },
  { value: 18403200, text: "More than 213 days", disabled: false },
  { value: 18489600, text: "More than 214 days", disabled: false },
  { value: 18576000, text: "More than 215 days", disabled: false },
  { value: 18662400, text: "More than 216 days", disabled: false },
  { value: 18748800, text: "More than 217 days", disabled: false },
  { value: 18835200, text: "More than 218 days", disabled: false },
  { value: 18921600, text: "More than 219 days", disabled: false },
  { value: 19008000, text: "More than 220 days", disabled: false },
  { value: 19094400, text: "More than 221 days", disabled: false },
  { value: 19180800, text: "More than 222 days", disabled: false },
  { value: 19267200, text: "More than 223 days", disabled: false },
  { value: 19353600, text: "More than 224 days", disabled: false },
  { value: 19440000, text: "More than 225 days", disabled: false },
  { value: 19526400, text: "More than 226 days", disabled: false },
  { value: 19612800, text: "More than 227 days", disabled: false },
  { value: 19699200, text: "More than 228 days", disabled: false },
  { value: 19785600, text: "More than 229 days", disabled: false },
  { value: 19872000, text: "More than 230 days", disabled: false },
  { value: 19958400, text: "More than 231 days", disabled: false },
  { value: 20044800, text: "More than 232 days", disabled: false },
  { value: 20131200, text: "More than 233 days", disabled: false },
  { value: 20217600, text: "More than 234 days", disabled: false },
  { value: 20304000, text: "More than 235 days", disabled: false },
  { value: 20390400, text: "More than 236 days", disabled: false },
  { value: 20476800, text: "More than 237 days", disabled: false },
  { value: 20563200, text: "More than 238 days", disabled: false },
  { value: 20649600, text: "More than 239 days", disabled: false },
  { value: 20736000, text: "More than 240 days", disabled: false },
  { value: 20822400, text: "More than 241 days", disabled: false },
  { value: 20908800, text: "More than 242 days", disabled: false },
  { value: 20995200, text: "More than 243 days", disabled: false },
  { value: 21081600, text: "More than 244 days", disabled: false },
  { value: 21168000, text: "More than 245 days", disabled: false },
  { value: 21254400, text: "More than 246 days", disabled: false },
  { value: 21340800, text: "More than 247 days", disabled: false },
  { value: 21427200, text: "More than 248 days", disabled: false },
  { value: 21513600, text: "More than 249 days", disabled: false },
  { value: 21600000, text: "More than 250 days", disabled: false },
  { value: 21686400, text: "More than 251 days", disabled: false },
  { value: 21772800, text: "More than 252 days", disabled: false },
  { value: 21859200, text: "More than 253 days", disabled: false },
  { value: 21945600, text: "More than 254 days", disabled: false },
  { value: 22032000, text: "More than 255 days", disabled: false },
  { value: 22118400, text: "More than 256 days", disabled: false },
  { value: 22204800, text: "More than 257 days", disabled: false },
  { value: 22291200, text: "More than 258 days", disabled: false },
  { value: 22377600, text: "More than 259 days", disabled: false },
  { value: 22464000, text: "More than 260 days", disabled: false },
  { value: 22550400, text: "More than 261 days", disabled: false },
  { value: 22636800, text: "More than 262 days", disabled: false },
  { value: 22723200, text: "More than 263 days", disabled: false },
  { value: 22809600, text: "More than 264 days", disabled: false },
  { value: 22896000, text: "More than 265 days", disabled: false },
  { value: 22982400, text: "More than 266 days", disabled: false },
  { value: 23068800, text: "More than 267 days", disabled: false },
  { value: 23155200, text: "More than 268 days", disabled: false },
  { value: 23241600, text: "More than 269 days", disabled: false },
  { value: 23328000, text: "More than 270 days", disabled: false },
  { value: 23414400, text: "More than 271 days", disabled: false },
  { value: 23500800, text: "More than 272 days", disabled: false },
  { value: 23587200, text: "More than 273 days", disabled: false },
  { value: 23673600, text: "More than 274 days", disabled: false },
  { value: 23760000, text: "More than 275 days", disabled: false },
  { value: 23846400, text: "More than 276 days", disabled: false },
  { value: 23932800, text: "More than 277 days", disabled: false },
  { value: 24019200, text: "More than 278 days", disabled: false },
  { value: 24105600, text: "More than 279 days", disabled: false },
  { value: 24192000, text: "More than 280 days", disabled: false },
  { value: 24278400, text: "More than 281 days", disabled: false },
  { value: 24364800, text: "More than 282 days", disabled: false },
  { value: 24451200, text: "More than 283 days", disabled: false },
  { value: 24537600, text: "More than 284 days", disabled: false },
  { value: 24624000, text: "More than 285 days", disabled: false },
  { value: 24710400, text: "More than 286 days", disabled: false },
  { value: 24796800, text: "More than 287 days", disabled: false },
  { value: 24883200, text: "More than 288 days", disabled: false },
  { value: 24969600, text: "More than 289 days", disabled: false },
  { value: 25056000, text: "More than 290 days", disabled: false },
  { value: 25142400, text: "More than 291 days", disabled: false },
  { value: 25228800, text: "More than 292 days", disabled: false },
  { value: 25315200, text: "More than 293 days", disabled: false },
  { value: 25401600, text: "More than 294 days", disabled: false },
  { value: 25488000, text: "More than 295 days", disabled: false },
  { value: 25574400, text: "More than 296 days", disabled: false },
  { value: 25660800, text: "More than 297 days", disabled: false },
  { value: 25747200, text: "More than 298 days", disabled: false },
  { value: 25833600, text: "More than 299 days", disabled: false },
  { value: 25920000, text: "More than 300 days", disabled: false },
  { value: 26006400, text: "More than 301 days", disabled: false },
  { value: 26092800, text: "More than 302 days", disabled: false },
  { value: 26179200, text: "More than 303 days", disabled: false },
  { value: 26265600, text: "More than 304 days", disabled: false },
  { value: 26352000, text: "More than 305 days", disabled: false },
  { value: 26438400, text: "More than 306 days", disabled: false },
  { value: 26524800, text: "More than 307 days", disabled: false },
  { value: 26611200, text: "More than 308 days", disabled: false },
  { value: 26697600, text: "More than 309 days", disabled: false },
  { value: 26784000, text: "More than 310 days", disabled: false },
  { value: 26870400, text: "More than 311 days", disabled: false },
  { value: 26956800, text: "More than 312 days", disabled: false },
  { value: 27043200, text: "More than 313 days", disabled: false },
  { value: 27129600, text: "More than 314 days", disabled: false },
  { value: 27216000, text: "More than 315 days", disabled: false },
  { value: 27302400, text: "More than 316 days", disabled: false },
  { value: 27388800, text: "More than 317 days", disabled: false },
  { value: 27475200, text: "More than 318 days", disabled: false },
  { value: 27561600, text: "More than 319 days", disabled: false },
  { value: 27648000, text: "More than 320 days", disabled: false },
  { value: 27734400, text: "More than 321 days", disabled: false },
  { value: 27820800, text: "More than 322 days", disabled: false },
  { value: 27907200, text: "More than 323 days", disabled: false },
  { value: 27993600, text: "More than 324 days", disabled: false },
  { value: 28080000, text: "More than 325 days", disabled: false },
  { value: 28166400, text: "More than 326 days", disabled: false },
  { value: 28252800, text: "More than 327 days", disabled: false },
  { value: 28339200, text: "More than 328 days", disabled: false },
  { value: 28425600, text: "More than 329 days", disabled: false },
  { value: 28512000, text: "More than 330 days", disabled: false },
  { value: 28598400, text: "More than 331 days", disabled: false },
  { value: 28684800, text: "More than 332 days", disabled: false },
  { value: 28771200, text: "More than 333 days", disabled: false },
  { value: 28857600, text: "More than 334 days", disabled: false },
  { value: 28944000, text: "More than 335 days", disabled: false },
  { value: 29030400, text: "More than 336 days", disabled: false },
  { value: 29116800, text: "More than 337 days", disabled: false },
  { value: 29203200, text: "More than 338 days", disabled: false },
  { value: 29289600, text: "More than 339 days", disabled: false },
  { value: 29376000, text: "More than 340 days", disabled: false },
  { value: 29462400, text: "More than 341 days", disabled: false },
  { value: 29548800, text: "More than 342 days", disabled: false },
  { value: 29635200, text: "More than 343 days", disabled: false },
  { value: 29721600, text: "More than 344 days", disabled: false },
  { value: 29808000, text: "More than 345 days", disabled: false },
  { value: 29894400, text: "More than 346 days", disabled: false },
  { value: 29980800, text: "More than 347 days", disabled: false },
  { value: 30067200, text: "More than 348 days", disabled: false },
  { value: 30153600, text: "More than 349 days", disabled: false },
  { value: 30240000, text: "More than 350 days", disabled: false },
  { value: 30326400, text: "More than 351 days", disabled: false },
  { value: 30412800, text: "More than 352 days", disabled: false },
  { value: 30499200, text: "More than 353 days", disabled: false },
  { value: 30585600, text: "More than 354 days", disabled: false },
  { value: 30672000, text: "More than 355 days", disabled: false },
  { value: 30758400, text: "More than 356 days", disabled: false },
  { value: 30844800, text: "More than 357 days", disabled: false },
  { value: 30931200, text: "More than 358 days", disabled: false },
  { value: 31017600, text: "More than 359 days", disabled: false },
  { value: 31104000, text: "More than 360 days", disabled: false },
  { value: 31190400, text: "More than 361 days", disabled: false },
  { value: 31276800, text: "More than 362 days", disabled: false },
  { value: 31363200, text: "More than 363 days", disabled: false },
  { value: 31449600, text: "More than 364 days", disabled: false },
  { value: 31536000, text: "More than 365 days", disabled: false },
];

export const cancellation_fee = [
  { value: 0, text: "0 %", disabled: false },
  { value: 5, text: "5 %", disabled: false },
  { value: 10, text: "10 %", disabled: false },
  { value: 15, text: "15 %", disabled: false },
  { value: 20, text: "20 %", disabled: false },
  { value: 25, text: "25 %", disabled: false },
  { value: 30, text: "30 %", disabled: false },
  { value: 35, text: "35 %", disabled: false },
  { value: 40, text: "40 %", disabled: false },
  { value: 45, text: "45 %", disabled: false },
  { value: 50, text: "50 %", disabled: false },
  { value: 55, text: "55 %", disabled: false },
  { value: 60, text: "60 %", disabled: false },
  { value: 65, text: "65 %", disabled: false },
  { value: 70, text: "70 %", disabled: false },
  { value: 75, text: "75 %", disabled: false },
  { value: 80, text: "80 %", disabled: false },
  { value: 85, text: "85 %", disabled: false },
  { value: 90, text: "90 %", disabled: false },
  { value: 95, text: "95 %", disabled: false },
  { value: 100, text: "100 %", disabled: false },
  { value: "FN", text: "First Night", disabled: false },
];

export const cancelled_within = [
  { value: 0, text: "No Show", disabled: false },
  { value: 86400, text: "1 day", disabled: false },
  { value: 172800, text: "2 days", disabled: false },
  { value: 259200, text: "3 days", disabled: false },
  { value: 345600, text: "4 days", disabled: false },
  { value: 432000, text: "5 days", disabled: false },
  { value: 518400, text: "6 days", disabled: false },
  { value: 604800, text: "7 days", disabled: false },
  { value: 691200, text: "8 days", disabled: false },
  { value: 777600, text: "9 days", disabled: false },
  { value: 864000, text: "10 days", disabled: false },
  { value: 950400, text: "11 days", disabled: false },
  { value: 1036800, text: "12 days", disabled: false },
  { value: 1123200, text: "13 days", disabled: false },
  { value: 1209600, text: "14 days", disabled: false },
  { value: 1296000, text: "15 days", disabled: false },
  { value: 1382400, text: "16 days", disabled: false },
  { value: 1468800, text: "17 days", disabled: false },
  { value: 1555200, text: "18 days", disabled: false },
  { value: 1641600, text: "19 days", disabled: false },
  { value: 1728000, text: "20 days", disabled: false },
  { value: 1814400, text: "21 days", disabled: false },
  { value: 1900800, text: "22 days", disabled: false },
  { value: 1987200, text: "23 days", disabled: false },
  { value: 2073600, text: "24 days", disabled: false },
  { value: 2160000, text: "25 days", disabled: false },
  { value: 2246400, text: "26 days", disabled: false },
  { value: 2332800, text: "27 days", disabled: false },
  { value: 2419200, text: "28 days", disabled: false },
  { value: 2505600, text: "29 days", disabled: false },
  { value: 2592000, text: "30 days", disabled: false },
  { value: 2678400, text: "31 days", disabled: false },
  { value: 2764800, text: "32 days", disabled: false },
  { value: 2851200, text: "33 days", disabled: false },
  { value: 2937600, text: "34 days", disabled: false },
  { value: 3024000, text: "35 days", disabled: false },
  { value: 3110400, text: "36 days", disabled: false },
  { value: 3196800, text: "37 days", disabled: false },
  { value: 3283200, text: "38 days", disabled: false },
  { value: 3369600, text: "39 days", disabled: false },
  { value: 3456000, text: "40 days", disabled: false },
  { value: 3542400, text: "41 days", disabled: false },
  { value: 3628800, text: "42 days", disabled: false },
  { value: 3715200, text: "43 days", disabled: false },
  { value: 3801600, text: "44 days", disabled: false },
  { value: 3888000, text: "45 days", disabled: false },
  { value: 3974400, text: "46 days", disabled: false },
  { value: 4060800, text: "47 days", disabled: false },
  { value: 4147200, text: "48 days", disabled: false },
  { value: 4233600, text: "49 days", disabled: false },
  { value: 4320000, text: "50 days", disabled: false },
  { value: 4406400, text: "51 days", disabled: false },
  { value: 4492800, text: "52 days", disabled: false },
  { value: 4579200, text: "53 days", disabled: false },
  { value: 4665600, text: "54 days", disabled: false },
  { value: 4752000, text: "55 days", disabled: false },
  { value: 4838400, text: "56 days", disabled: false },
  { value: 4924800, text: "57 days", disabled: false },
  { value: 5011200, text: "58 days", disabled: false },
  { value: 5097600, text: "59 days", disabled: false },
  { value: 5184000, text: "60 days", disabled: false },
  { value: 5270400, text: "61 days", disabled: false },
  { value: 5356800, text: "62 days", disabled: false },
  { value: 5443200, text: "63 days", disabled: false },
  { value: 5529600, text: "64 days", disabled: false },
  { value: 5616000, text: "65 days", disabled: false },
  { value: 5702400, text: "66 days", disabled: false },
  { value: 5788800, text: "67 days", disabled: false },
  { value: 5875200, text: "68 days", disabled: false },
  { value: 5961600, text: "69 days", disabled: false },
  { value: 6048000, text: "70 days", disabled: false },
  { value: 6134400, text: "71 days", disabled: false },
  { value: 6220800, text: "72 days", disabled: false },
  { value: 6307200, text: "73 days", disabled: false },
  { value: 6393600, text: "74 days", disabled: false },
  { value: 6480000, text: "75 days", disabled: false },
  { value: 6566400, text: "76 days", disabled: false },
  { value: 6652800, text: "77 days", disabled: false },
  { value: 6739200, text: "78 days", disabled: false },
  { value: 6825600, text: "79 days", disabled: false },
  { value: 6912000, text: "80 days", disabled: false },
  { value: 6998400, text: "81 days", disabled: false },
  { value: 7084800, text: "82 days", disabled: false },
  { value: 7171200, text: "83 days", disabled: false },
  { value: 7257600, text: "84 days", disabled: false },
  { value: 7344000, text: "85 days", disabled: false },
  { value: 7430400, text: "86 days", disabled: false },
  { value: 7516800, text: "87 days", disabled: false },
  { value: 7603200, text: "88 days", disabled: false },
  { value: 7689600, text: "89 days", disabled: false },
  { value: 7776000, text: "90 days", disabled: false },
  { value: 7862400, text: "91 days", disabled: false },
  { value: 7948800, text: "92 days", disabled: false },
  { value: 8035200, text: "93 days", disabled: false },
  { value: 8121600, text: "94 days", disabled: false },
  { value: 8208000, text: "95 days", disabled: false },
  { value: 8294400, text: "96 days", disabled: false },
  { value: 8380800, text: "97 days", disabled: false },
  { value: 8467200, text: "98 days", disabled: false },
  { value: 8553600, text: "99 days", disabled: false },
  { value: 8640000, text: "100 days", disabled: false },
  { value: 8726400, text: "101 days", disabled: false },
  { value: 8812800, text: "102 days", disabled: false },
  { value: 8899200, text: "103 days", disabled: false },
  { value: 8985600, text: "104 days", disabled: false },
  { value: 9072000, text: "105 days", disabled: false },
  { value: 9158400, text: "106 days", disabled: false },
  { value: 9244800, text: "107 days", disabled: false },
  { value: 9331200, text: "108 days", disabled: false },
  { value: 9417600, text: "109 days", disabled: false },
  { value: 9504000, text: "110 days", disabled: false },
  { value: 9590400, text: "111 days", disabled: false },
  { value: 9676800, text: "112 days", disabled: false },
  { value: 9763200, text: "113 days", disabled: false },
  { value: 9849600, text: "114 days", disabled: false },
  { value: 9936000, text: "115 days", disabled: false },
  { value: 10022400, text: "116 days", disabled: false },
  { value: 10108800, text: "117 days", disabled: false },
  { value: 10195200, text: "118 days", disabled: false },
  { value: 10281600, text: "119 days", disabled: false },
  { value: 10368000, text: "120 days", disabled: false },
  { value: 10454400, text: "121 days", disabled: false },
  { value: 10540800, text: "122 days", disabled: false },
  { value: 10627200, text: "123 days", disabled: false },
  { value: 10713600, text: "124 days", disabled: false },
  { value: 10800000, text: "125 days", disabled: false },
  { value: 10886400, text: "126 days", disabled: false },
  { value: 10972800, text: "127 days", disabled: false },
  { value: 11059200, text: "128 days", disabled: false },
  { value: 11145600, text: "129 days", disabled: false },
  { value: 11232000, text: "130 days", disabled: false },
  { value: 11318400, text: "131 days", disabled: false },
  { value: 11404800, text: "132 days", disabled: false },
  { value: 11491200, text: "133 days", disabled: false },
  { value: 11577600, text: "134 days", disabled: false },
  { value: 11664000, text: "135 days", disabled: false },
  { value: 11750400, text: "136 days", disabled: false },
  { value: 11836800, text: "137 days", disabled: false },
  { value: 11923200, text: "138 days", disabled: false },
  { value: 12009600, text: "139 days", disabled: false },
  { value: 12096000, text: "140 days", disabled: false },
  { value: 12182400, text: "141 days", disabled: false },
  { value: 12268800, text: "142 days", disabled: false },
  { value: 12355200, text: "143 days", disabled: false },
  { value: 12441600, text: "144 days", disabled: false },
  { value: 12528000, text: "145 days", disabled: false },
  { value: 12614400, text: "146 days", disabled: false },
  { value: 12700800, text: "147 days", disabled: false },
  { value: 12787200, text: "148 days", disabled: false },
  { value: 12873600, text: "149 days", disabled: false },
  { value: 12960000, text: "150 days", disabled: false },
  { value: 13046400, text: "151 days", disabled: false },
  { value: 13132800, text: "152 days", disabled: false },
  { value: 13219200, text: "153 days", disabled: false },
  { value: 13305600, text: "154 days", disabled: false },
  { value: 13392000, text: "155 days", disabled: false },
  { value: 13478400, text: "156 days", disabled: false },
  { value: 13564800, text: "157 days", disabled: false },
  { value: 13651200, text: "158 days", disabled: false },
  { value: 13737600, text: "159 days", disabled: false },
  { value: 13824000, text: "160 days", disabled: false },
  { value: 13910400, text: "161 days", disabled: false },
  { value: 13996800, text: "162 days", disabled: false },
  { value: 14083200, text: "163 days", disabled: false },
  { value: 14169600, text: "164 days", disabled: false },
  { value: 14256000, text: "165 days", disabled: false },
  { value: 14342400, text: "166 days", disabled: false },
  { value: 14428800, text: "167 days", disabled: false },
  { value: 14515200, text: "168 days", disabled: false },
  { value: 14601600, text: "169 days", disabled: false },
  { value: 14688000, text: "170 days", disabled: false },
  { value: 14774400, text: "171 days", disabled: false },
  { value: 14860800, text: "172 days", disabled: false },
  { value: 14947200, text: "173 days", disabled: false },
  { value: 15033600, text: "174 days", disabled: false },
  { value: 15120000, text: "175 days", disabled: false },
  { value: 15206400, text: "176 days", disabled: false },
  { value: 15292800, text: "177 days", disabled: false },
  { value: 15379200, text: "178 days", disabled: false },
  { value: 15465600, text: "179 days", disabled: false },
  { value: 15552000, text: "180 days", disabled: false },
  { value: 15638400, text: "181 days", disabled: false },
  { value: 15724800, text: "182 days", disabled: false },
  { value: 15811200, text: "183 days", disabled: false },
  { value: 15897600, text: "184 days", disabled: false },
  { value: 15984000, text: "185 days", disabled: false },
  { value: 16070400, text: "186 days", disabled: false },
  { value: 16156800, text: "187 days", disabled: false },
  { value: 16243200, text: "188 days", disabled: false },
  { value: 16329600, text: "189 days", disabled: false },
  { value: 16416000, text: "190 days", disabled: false },
  { value: 16502400, text: "191 days", disabled: false },
  { value: 16588800, text: "192 days", disabled: false },
  { value: 16675200, text: "193 days", disabled: false },
  { value: 16761600, text: "194 days", disabled: false },
  { value: 16848000, text: "195 days", disabled: false },
  { value: 16934400, text: "196 days", disabled: false },
  { value: 17020800, text: "197 days", disabled: false },
  { value: 17107200, text: "198 days", disabled: false },
  { value: 17193600, text: "199 days", disabled: false },
  { value: 17280000, text: "200 days", disabled: false },
  { value: 17366400, text: "201 days", disabled: false },
  { value: 17452800, text: "202 days", disabled: false },
  { value: 17539200, text: "203 days", disabled: false },
  { value: 17625600, text: "204 days", disabled: false },
  { value: 17712000, text: "205 days", disabled: false },
  { value: 17798400, text: "206 days", disabled: false },
  { value: 17884800, text: "207 days", disabled: false },
  { value: 17971200, text: "208 days", disabled: false },
  { value: 18057600, text: "209 days", disabled: false },
  { value: 18144000, text: "210 days", disabled: false },
  { value: 18230400, text: "211 days", disabled: false },
  { value: 18316800, text: "212 days", disabled: false },
  { value: 18403200, text: "213 days", disabled: false },
  { value: 18489600, text: "214 days", disabled: false },
  { value: 18576000, text: "215 days", disabled: false },
  { value: 18662400, text: "216 days", disabled: false },
  { value: 18748800, text: "217 days", disabled: false },
  { value: 18835200, text: "218 days", disabled: false },
  { value: 18921600, text: "219 days", disabled: false },
  { value: 19008000, text: "220 days", disabled: false },
  { value: 19094400, text: "221 days", disabled: false },
  { value: 19180800, text: "222 days", disabled: false },
  { value: 19267200, text: "223 days", disabled: false },
  { value: 19353600, text: "224 days", disabled: false },
  { value: 19440000, text: "225 days", disabled: false },
  { value: 19526400, text: "226 days", disabled: false },
  { value: 19612800, text: "227 days", disabled: false },
  { value: 19699200, text: "228 days", disabled: false },
  { value: 19785600, text: "229 days", disabled: false },
  { value: 19872000, text: "230 days", disabled: false },
  { value: 19958400, text: "231 days", disabled: false },
  { value: 20044800, text: "232 days", disabled: false },
  { value: 20131200, text: "233 days", disabled: false },
  { value: 20217600, text: "234 days", disabled: false },
  { value: 20304000, text: "235 days", disabled: false },
  { value: 20390400, text: "236 days", disabled: false },
  { value: 20476800, text: "237 days", disabled: false },
  { value: 20563200, text: "238 days", disabled: false },
  { value: 20649600, text: "239 days", disabled: false },
  { value: 20736000, text: "240 days", disabled: false },
  { value: 20822400, text: "241 days", disabled: false },
  { value: 20908800, text: "242 days", disabled: false },
  { value: 20995200, text: "243 days", disabled: false },
  { value: 21081600, text: "244 days", disabled: false },
  { value: 21168000, text: "245 days", disabled: false },
  { value: 21254400, text: "246 days", disabled: false },
  { value: 21340800, text: "247 days", disabled: false },
  { value: 21427200, text: "248 days", disabled: false },
  { value: 21513600, text: "249 days", disabled: false },
  { value: 21600000, text: "250 days", disabled: false },
  { value: 21686400, text: "251 days", disabled: false },
  { value: 21772800, text: "252 days", disabled: false },
  { value: 21859200, text: "253 days", disabled: false },
  { value: 21945600, text: "254 days", disabled: false },
  { value: 22032000, text: "255 days", disabled: false },
  { value: 22118400, text: "256 days", disabled: false },
  { value: 22204800, text: "257 days", disabled: false },
  { value: 22291200, text: "258 days", disabled: false },
  { value: 22377600, text: "259 days", disabled: false },
  { value: 22464000, text: "260 days", disabled: false },
  { value: 22550400, text: "261 days", disabled: false },
  { value: 22636800, text: "262 days", disabled: false },
  { value: 22723200, text: "263 days", disabled: false },
  { value: 22809600, text: "264 days", disabled: false },
  { value: 22896000, text: "265 days", disabled: false },
  { value: 22982400, text: "266 days", disabled: false },
  { value: 23068800, text: "267 days", disabled: false },
  { value: 23155200, text: "268 days", disabled: false },
  { value: 23241600, text: "269 days", disabled: false },
  { value: 23328000, text: "270 days", disabled: false },
  { value: 23414400, text: "271 days", disabled: false },
  { value: 23500800, text: "272 days", disabled: false },
  { value: 23587200, text: "273 days", disabled: false },
  { value: 23673600, text: "274 days", disabled: false },
  { value: 23760000, text: "275 days", disabled: false },
  { value: 23846400, text: "276 days", disabled: false },
  { value: 23932800, text: "277 days", disabled: false },
  { value: 24019200, text: "278 days", disabled: false },
  { value: 24105600, text: "279 days", disabled: false },
  { value: 24192000, text: "280 days", disabled: false },
  { value: 24278400, text: "281 days", disabled: false },
  { value: 24364800, text: "282 days", disabled: false },
  { value: 24451200, text: "283 days", disabled: false },
  { value: 24537600, text: "284 days", disabled: false },
  { value: 24624000, text: "285 days", disabled: false },
  { value: 24710400, text: "286 days", disabled: false },
  { value: 24796800, text: "287 days", disabled: false },
  { value: 24883200, text: "288 days", disabled: false },
  { value: 24969600, text: "289 days", disabled: false },
  { value: 25056000, text: "290 days", disabled: false },
  { value: 25142400, text: "291 days", disabled: false },
  { value: 25228800, text: "292 days", disabled: false },
  { value: 25315200, text: "293 days", disabled: false },
  { value: 25401600, text: "294 days", disabled: false },
  { value: 25488000, text: "295 days", disabled: false },
  { value: 25574400, text: "296 days", disabled: false },
  { value: 25660800, text: "297 days", disabled: false },
  { value: 25747200, text: "298 days", disabled: false },
  { value: 25833600, text: "299 days", disabled: false },
  { value: 25920000, text: "300 days", disabled: false },
  { value: 26006400, text: "301 days", disabled: false },
  { value: 26092800, text: "302 days", disabled: false },
  { value: 26179200, text: "303 days", disabled: false },
  { value: 26265600, text: "304 days", disabled: false },
  { value: 26352000, text: "305 days", disabled: false },
  { value: 26438400, text: "306 days", disabled: false },
  { value: 26524800, text: "307 days", disabled: false },
  { value: 26611200, text: "308 days", disabled: false },
  { value: 26697600, text: "309 days", disabled: false },
  { value: 26784000, text: "310 days", disabled: false },
  { value: 26870400, text: "311 days", disabled: false },
  { value: 26956800, text: "312 days", disabled: false },
  { value: 27043200, text: "313 days", disabled: false },
  { value: 27129600, text: "314 days", disabled: false },
  { value: 27216000, text: "315 days", disabled: false },
  { value: 27302400, text: "316 days", disabled: false },
  { value: 27388800, text: "317 days", disabled: false },
  { value: 27475200, text: "318 days", disabled: false },
  { value: 27561600, text: "319 days", disabled: false },
  { value: 27648000, text: "320 days", disabled: false },
  { value: 27734400, text: "321 days", disabled: false },
  { value: 27820800, text: "322 days", disabled: false },
  { value: 27907200, text: "323 days", disabled: false },
  { value: 27993600, text: "324 days", disabled: false },
  { value: 28080000, text: "325 days", disabled: false },
  { value: 28166400, text: "326 days", disabled: false },
  { value: 28252800, text: "327 days", disabled: false },
  { value: 28339200, text: "328 days", disabled: false },
  { value: 28425600, text: "329 days", disabled: false },
  { value: 28512000, text: "330 days", disabled: false },
  { value: 28598400, text: "331 days", disabled: false },
  { value: 28684800, text: "332 days", disabled: false },
  { value: 28771200, text: "333 days", disabled: false },
  { value: 28857600, text: "334 days", disabled: false },
  { value: 28944000, text: "335 days", disabled: false },
  { value: 29030400, text: "336 days", disabled: false },
  { value: 29116800, text: "337 days", disabled: false },
  { value: 29203200, text: "338 days", disabled: false },
  { value: 29289600, text: "339 days", disabled: false },
  { value: 29376000, text: "340 days", disabled: false },
  { value: 29462400, text: "341 days", disabled: false },
  { value: 29548800, text: "342 days", disabled: false },
  { value: 29635200, text: "343 days", disabled: false },
  { value: 29721600, text: "344 days", disabled: false },
  { value: 29808000, text: "345 days", disabled: false },
  { value: 29894400, text: "346 days", disabled: false },
  { value: 29980800, text: "347 days", disabled: false },
  { value: 30067200, text: "348 days", disabled: false },
  { value: 30153600, text: "349 days", disabled: false },
  { value: 30240000, text: "350 days", disabled: false },
  { value: 30326400, text: "351 days", disabled: false },
  { value: 30412800, text: "352 days", disabled: false },
  { value: 30499200, text: "353 days", disabled: false },
  { value: 30585600, text: "354 days", disabled: false },
  { value: 30672000, text: "355 days", disabled: false },
  { value: 30758400, text: "356 days", disabled: false },
  { value: 30844800, text: "357 days", disabled: false },
  { value: 30931200, text: "358 days", disabled: false },
  { value: 31017600, text: "359 days", disabled: false },
  { value: 31104000, text: "360 days", disabled: false },
  { value: 31190400, text: "361 days", disabled: false },
  { value: 31276800, text: "362 days", disabled: false },
  { value: 31363200, text: "363 days", disabled: false },
  { value: 31449600, text: "364 days", disabled: false },
  { value: 31536000, text: "365 days", disabled: false },
];

export const time_zones = [
  "America/Adak",
  "America/Anchorage",
  "America/Anguilla",
  "America/Antigua",
  "America/Araguaina",
  "America/Argentina/Buenos_Aires",
  "America/Argentina/Catamarca",
  "America/Argentina/ComodRivadavia",
  "America/Argentina/Cordoba",
  "America/Argentina/Jujuy",
  "America/Argentina/La_Rioja",
  "America/Argentina/Mendoza",
  "America/Argentina/Rio_Gallegos",
  "America/Argentina/Salta",
  "America/Argentina/San_Juan",
  "America/Argentina/San_Luis",
  "America/Argentina/Tucuman",
  "America/Argentina/Ushuaia",
  "America/Aruba",
  "America/Asuncion",
  "America/Atikokan",
  "America/Atka",
  "America/Bahia",
  "America/Bahia_Banderas",
  "America/Barbados",
  "America/Belem",
  "America/Belize",
  "America/Blanc-Sablon",
  "America/Boa_Vista",
  "America/Bogota",
  "America/Boise",
  "America/Buenos_Aires",
  "America/Cambridge_Bay",
  "America/Campo_Grande",
  "America/Cancun",
  "America/Caracas",
  "America/Catamarca",
  "America/Cayenne",
  "America/Cayman",
  "America/Chicago",
  "America/Chihuahua",
  "America/Coral_Harbour",
  "America/Cordoba",
  "America/Costa_Rica",
  "America/Creston",
  "America/Cuiaba",
  "America/Curacao",
  "America/Danmarkshavn",
  "America/Dawson",
  "America/Dawson_Creek",
  "America/Denver",
  "America/Detroit",
  "America/Dominica",
  "America/Edmonton",
  "America/Eirunepe",
  "America/El_Salvador",
  "America/Ensenada",
  "America/Fort_Nelson",
  "America/Fort_Wayne",
  "America/Fortaleza",
  "America/Glace_Bay",
  "America/Godthab",
  "America/Goose_Bay",
  "America/Grand_Turk",
  "America/Grenada",
  "America/Guadeloupe",
  "America/Guatemala",
  "America/Guayaquil",
  "America/Guyana",
  "America/Halifax",
  "America/Havana",
  "America/Hermosillo",
  "America/Indiana/Indianapolis",
  "America/Indiana/Knox",
  "America/Indiana/Marengo",
  "America/Indiana/Petersburg",
  "America/Indiana/Tell_City",
  "America/Indiana/Vevay",
  "America/Indiana/Vincennes",
  "America/Indiana/Winamac",
  "America/Indianapolis",
  "America/Inuvik",
  "America/Iqaluit",
  "America/Jamaica",
  "America/Jujuy",
  "America/Juneau",
  "America/Kentucky/Louisville",
  "America/Kentucky/Monticello",
  "America/Knox_IN",
  "America/Kralendijk",
  "America/La_Paz",
  "America/Lima",
  "America/Los_Angeles",
  "America/Louisville",
  "America/Lower_Princes",
  "America/Maceio",
  "America/Managua",
  "America/Manaus",
  "America/Marigot",
  "America/Martinique",
  "America/Matamoros",
  "America/Mazatlan",
  "America/Mendoza",
  "America/Menominee",
  "America/Merida",
  "America/Metlakatla",
  "America/Mexico_City",
  "America/Miquelon",
  "America/Moncton",
  "America/Monterrey",
  "America/Montevideo",
  "America/Montreal",
  "America/Montserrat",
  "America/Nassau",
  "America/New_York",
  "America/Nipigon",
  "America/Nome",
  "America/Noronha",
  "America/North_Dakota/Beulah",
  "America/North_Dakota/Center",
  "America/North_Dakota/New_Salem",
  "America/Ojinaga",
  "America/Panama",
  "America/Pangnirtung",
  "America/Paramaribo",
  "America/Phoenix",
  "America/Port-au-Prince",
  "America/Port_of_Spain",
  "America/Porto_Acre",
  "America/Porto_Velho",
  "America/Puerto_Rico",
  "America/Punta_Arenas",
  "America/Rainy_River",
  "America/Rankin_Inlet",
  "America/Recife",
  "America/Regina",
  "America/Resolute",
  "America/Rio_Branco",
  "America/Rosario",
  "America/Santa_Isabel",
  "America/Santarem",
  "America/Santiago",
  "America/Santo_Domingo",
  "America/Sao_Paulo",
  "America/Scoresbysund",
  "America/Shiprock",
  "America/Sitka",
  "America/St_Barthelemy",
  "America/St_Johns",
  "America/St_Kitts",
  "America/St_Lucia",
  "America/St_Thomas",
  "America/St_Vincent",
  "America/Swift_Current",
  "America/Tegucigalpa",
  "America/Thule",
  "America/Thunder_Bay",
  "America/Tijuana",
  "America/Toronto",
  "America/Tortola",
  "America/Vancouver",
  "America/Virgin",
  "America/Whitehorse",
  "America/Winnipeg",
  "America/Yakutat",
  "America/Yellowknife",
  "Asia/Aden",
  "US/Alaska",
  "US/Aleutian",
  "US/Arizona",
  "US/Central",
  "US/East-Indiana",
  "US/Eastern",
  "US/Hawaii",
  "US/Indiana-Starke",
  "US/Michigan",
  "US/Mountain",
  "US/Pacific",
  "US/Pacific-New",
  "US/Samoa",
];

// * Maintenance request related data
export const otherOptions = [
  { text: "Pending", value: "pending" },
  { text: "Assigned", value: "assigned" },
  { text: "In Progress", value: "in_progress" },
  { text: "Completed", value: "completed" },
  { text: "Re Open", value: "re_open" },
];

export const priorityOpt = [
  { text: "Normal", value: "normal" },
  { text: "Urgent", value: "urgent" },
  { text: "High", value: "high" },
];

export const typeOptions = [
  { text: "Internal", value: true },
  { text: "External", value: false },
];

// * Invoice related data
export const mileageUnit = [
  { text: "Kilometer", value: "kilometer" },
  { text: "Mile", value: "mile" },
];

export const currencyFormat = [
  { text: "ISO Code (USD)", value: "iso" },
  { text: "Symbol ($)", value: "symbol" },
];

export const currencyPosition = [
  { text: "Left of amount", value: "left" },
  { text: "Right of amount", value: "right" },
];

export const currency = [
  { text: "USD", value: "usd", disabled: false },
  { text: "CAD", value: "cad", disabled: false },
  { text: "INR", value: "inr", disabled: false },
];

export const estimateTab = [
  { text: "Archived", value: "archived", disabled: false },
  { text: "All", value: "all", disabled: false },
  { text: "Draft", value: "draft", disabled: false },
  { text: "Accepted", value: "accepted", disabled: false },
  { text: "Pending", value: "pending", disabled: false },
  { text: "Expired", value: "expired", disabled: false },
];

export const invoiceDefault = [
  { text: "Archived", value: "archived", disabled: false },
  { text: "All", value: "all", disabled: false },
  { text: "Draft", value: "draft", disabled: false },
  { text: "Paid", value: "paid", disabled: false },
  { text: "Unpaid", value: "unpaid", disabled: false },
  { text: "Overdue", value: "overdue", disabled: false },
];

export const leadDefault = [
  { text: "Archived", value: "archived", disabled: false },
  { text: "All", value: "all", disabled: false },
  { text: "Draft", value: "draft", disabled: false },
  { text: "Paid", value: "paid", disabled: false },
  { text: "Unpaid", value: "unpaid", disabled: false },
  { text: "Overdue", value: "overdue", disabled: false },
];

export const numberFormat = [
  { text: "100,000.00", value: "comma_dot", disabled: false },
  { text: "100.000,00", value: "dot_comma", disabled: false },
  { text: "100 000.00", value: "space_dot", disabled: false },
  { text: "100 000,00", value: "space_comma", disabled: false },
  { text: "100000.00", value: "swiss", disabled: false },
  { text: "100000,00", value: "swiss_german", disabled: false },
];

export const pmsType = [
  { text: "Anand system Inetreface", value: "asi" },
  { text: "Mitel", value: "mitel" },
  { text: "Hotel Key", value: "hotel_key" },
  { text: "FIAS", value: "fias" },
  { text: "WebRez", value: "webRez" },
];

export const language = [
  { text: "English (US)", value: "en" },
  { text: "English (UK)", value: "en-GB" },
  { text: "Chinese", value: "zh" },
  { text: "Czech", value: "cs" },
  { text: "Danish", value: "da" },
  { text: "Dutch", value: "nl" },
  { text: "Estonian", value: "et" },
  { text: "Filipino", value: "tl" },
  { text: "French", value: "fr" },
  { text: "German", value: "de" },
  { text: "Greek", value: "el" },
  { text: "Hindi", value: "hi" },
  { text: "Italian", value: "it" },
  { text: "Japanese", value: "ja" },
  { text: "Korean", value: "ko" },
  { text: "Malay", value: "ms" },
  { text: "Portuguese", value: "pt" },
  { text: "Portuguese (Brazil)", value: "pt-BR" },
  { text: "Romanian", value: "ro" },
  { text: "Russian", value: "ru" },
  { text: "Sinhala", value: "si" },
  { text: "Slovak", value: "sk" },
  { text: "Spanish", value: "es" },
  { text: "Swedish", value: "sv" },
];
